import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { EpisodeHero } from "@/components/EpisodeHero";
import { EpisodeCard } from "@/components/EpisodeCard";
import { NotesDialog } from "@/components/ExpandableText";
import { Skeleton } from "@/components/ui/skeleton";
import { useSettings } from "@/context/SettingsContext";

export const LatestEpisodes = () => {
  const [episodes, setEpisodes] = useState(null);
  const { settings, homepage } = useSettings();

  useEffect(() => {
    if (!settings) return;
    api.get("/episodes/latest", { params: { limit: homepage.latest_count || 9 } }).then((r) => setEpisodes(r.data)).catch(() => setEpisodes([]));
  }, [settings, homepage.latest_count]);

  const [notes, setNotes] = useState(null);

  const feature = (ep) => {
    setEpisodes((list) => {
      const i = list.findIndex((x) => x.id === ep.id);
      if (i <= 0) return list;
      const next = [...list];
      [next[0], next[i]] = [next[i], next[0]];
      return next;
    });
    document.getElementById("latest")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const readMore = (ep) => { feature(ep); setNotes(ep); };

  return (
    <section id="latest" className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-8 sm:pt-10" data-testid="latest-episodes-section">
      <div className="mb-6">
        {homepage.latest_section_eyebrow !== "" && <p className="eyebrow mb-2" data-testid="latest-episodes-eyebrow">{homepage.latest_section_eyebrow || "Listen"}</p>}
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="latest-episodes-title">{homepage.latest_title || "Latest Episodes"}</h1>
      </div>

      {!episodes ? (
        <div className="space-y-6">
          <Skeleton className="h-[380px] rounded-3xl bg-white/5" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{[...Array(8)].map((_, i) => <Skeleton key={i} className="h-36 rounded-2xl bg-white/5" />)}</div>
        </div>
      ) : episodes.length === 0 ? (
        <div className="card-surface rounded-3xl p-12 text-center text-slate-400" data-testid="latest-episodes-empty">No episodes yet. Add a show in the admin dashboard to get started.</div>
      ) : (
        <>
          <EpisodeHero key={episodes[0].id} episode={episodes[0]} eyebrow={homepage.latest_eyebrow || "Newest on the network"} />
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 min-w-0" data-testid="latest-episodes-grid">
            {episodes.slice(1).map((ep, i) => <EpisodeCard key={ep.id} episode={ep} index={i + 1} onSelect={feature} onReadMore={readMore} />)}
          </div>
          <NotesDialog open={!!notes} onOpenChange={(o) => !o && setNotes(null)} title={notes?.title} eyebrow={notes?.show?.name} text={notes?.description || notes?.summary} testId="latest-notes" />
        </>
      )}
    </section>
  );
};
